import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Splide from "@splidejs/splide";
import CustomAnimation from "src/scripts/animation/customAnimation";

let splide1;
let followupVideoIsPlaying = false;
const customAnmation = new CustomAnimation();


class Landingpage {
  init() {
    this.initPage();
    this.initCaroussel();
    this.initVideo();
    this.initAccordion();
    this.initParallax();
    this.onScroll();
  }

  initPage = () => {
    $('.background').each(function() {
      jQuery(this).css("background-image", "url("+ jQuery(this).data('bg-image') +")");
    });
  }

  initCaroussel = () => {
    if(jQuery('.splide_01').length > 0) {
      splide1 = new Splide('.splide_01', {
        type: 'loop',
        perPage: 1,
        focus: 'center',
        autoplay: false,
        flickMaxPages: 3,
        updateOnMove: true,
        pagination: true,
        throttle: 300
      });

      splide1.mount();

      setTimeout(function () {
        splide1.refresh();
      }, 500);
    }
  }

  initVideo = () => {
    if( $('.followup_video').get(0) == undefined)
    {
      return;
    }

    $('.followup_video').get(0).pause();

    $('.followup_video_holder').click(function() {

      if (followupVideoIsPlaying === false) {
        followupVideoIsPlaying = true;
        $('.followup_video_button').addClass('hide');
        $('.followup_video').get(0).play();
      }
      else {
        followupVideoIsPlaying = false;
        $('.followup_video_button').removeClass('hide');
        $('.followup_video').get(0).pause();
      }
    });
  }

  initAccordion = () => {
    // accordion
    $('.button_faq').click(function(e){
      e.preventDefault();
      $(this).next(".faq_content").slideToggle();
      $(this).closest("li").siblings().find('.faq_content').slideUp();

      if( $(this).hasClass('open') ) {
        $('.button_faq').removeClass("open");
        $(this).removeClass('open')
      }
      else {
        $('.button_faq').removeClass("open");
        $(this).addClass('open')
      }
    });

    $('.faq_holder ul li:first-child .button_faq').addClass('button_faq_1');

    $('.button_faq_1').trigger('click');

  }

  initParallax = () =>  {
    gsap.registerPlugin(ScrollTrigger);

    gsap.config({
      nullTargetWarn: false
    })

    customAnmation.animateHeaderImage('.video_holder');

    customAnmation.animateBgImage('.demo_background', '.demo');
    customAnmation.animateText('.demo_text_holder');
    customAnmation.animateText('.demo_form_holder');

    customAnmation.animateBgImage('.decisions_background', '.decisions');
    customAnmation.animateText('.decisions_text_holder');
    customAnmation.animateGroup('.decisions_box');

    customAnmation.animateBgImage('.logos_background', '.logos');
    customAnmation.animateText('.logos_text_holder');
    customAnmation.animateGroup('.logo');

    customAnmation.animateBgImage('.customer_background', '.customer');
    customAnmation.animateText('.customer_text_holder');
    customAnmation.animateText('.customer_holder');

    customAnmation.animateBgImage('.faq_background', '.faq');
    customAnmation.animateText('.faq_text_holder');
    customAnmation.animateText('.faq_holder');


  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        let scrollPos = $(document).scrollTop();

        // header video
        if(scrollPos > 200) {
          //$('.home_video').get(0).pause();
        }
        else {
          //$('.home_video').get(0).play();
        }

      }).scroll();
  };
}

export default Landingpage;
